import React from 'react';
import { IClientContact, ISupplierContact } from '@bb/contacts';
import { OrgFeatureMap } from 'utils';
import { PopulatedUser } from '../../../api/UserController/getProfile';

import { ContactDrawerType, ContactDrawerUser } from '../types';
import { ProfileSkeleton } from './Profile/common';
import ContactProfile from './Profile/ContactProfile';
import UserProfile from './Profile/UserProfile';

interface DrawerProfileProps {
  contact: ContactDrawerUser;
  loading: boolean;
  type: ContactDrawerType;
  contactFeatureMap: OrgFeatureMap;
}

const DrawerProfile: React.FC<DrawerProfileProps> = ({
  contact,
  contactFeatureMap,
  type,
  loading,
  ...props
}) => {
  if (loading || !contact) {
    return ProfileSkeleton;
  }

  if (type === ContactDrawerType.Contact) {
    return (
      <ContactProfile
        contact={contact as IClientContact | ISupplierContact}
        {...props}
      />
    );
  }

  if (type === ContactDrawerType.User) {
    return (
      <UserProfile
        contact={contact as PopulatedUser}
        contactFeatureMap={contactFeatureMap}
        {...props}
      />
    );
  }

  return null;
};

export default DrawerProfile;
